import axios from 'axios'

// firstName, LastName, email, password
export const userSignupService = async (userData) => {
    try {
        return await axios.post(`/api/users/signup`, userData)
    } catch (err) {
        return {
            error: true,
            response: err.response,
        }
    }
}

export const getUserService = async () => {
    try {
        return await axios.get(`/api/users/getUser`)
    } catch (err) {
        return { error: true, response: err.response }
    }
}

export const updateUserService = async (userData) => {
    try {
        return await axios.post(`/api/users/updateUser`, userData)
    } catch (err) {
        return { error: true, response: err.response }
    }
}

export const updateUserPassword = async (userData) => {
    try {
        return await axios.post(`/api/users/changepassword`, userData)
    } catch (err) {
        return { error: true, response: err.response }
    }
}
